import { useMemo } from 'react';
import { isNil, isNotNil } from 'shared/src/utils';
import { useGoodsOptionsBrief } from '../components/SelectOptionBottomSheet/queries/useGoodsOptionsBrief';

export type InlineOptionMode = 'standard' | 'inline';

export const useInlineOptionMode = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}): InlineOptionMode => {
  const { data: brief } = useGoodsOptionsBrief();

  return useMemo<InlineOptionMode>(() => {
    if (!enabled || !brief) return 'standard';
    const eligible =
      brief.enable_quick_option_pick === true &&
      isNil(brief.text_option) &&
      brief.option_groups.length === 2 &&
      brief.option_groups.every(g => isNotNil(g.first_goods_option_sno));
    return eligible ? 'inline' : 'standard';
  }, [brief, enabled]);
};
